import { render, staticRenderFns } from "./ProductsSlider.vue?vue&type=template&id=29584983&scoped=true&"
import script from "./ProductsSlider.vue?vue&type=script&lang=js&"
export * from "./ProductsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSlider.vue?vue&type=style&index=0&id=29584983&scoped=true&lang=sass&"
import style1 from "./ProductsSlider.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29584983",
  null
  
)

export default component.exports